import { render, staticRenderFns } from "./siteInfo.vue?vue&type=template&id=9edde610&scoped=true&"
import script from "./siteInfo.vue?vue&type=script&lang=js&"
export * from "./siteInfo.vue?vue&type=script&lang=js&"
import style0 from "./siteInfo.vue?vue&type=style&index=0&id=9edde610&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edde610",
  null
  
)

export default component.exports